var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { space } from '../../utils/space';
import { Box } from '../Box/Box';
import { Icon } from '../Icon/Icon';
import { useColorSet } from '../ThemeProvider/useColorSet';
import { useTheme } from '../ThemeProvider/useTheme';
import { Typography } from '../Typography/Typography';
const severityMapping = {
    error: 'critical',
    warning: 'warning',
    success: 'success',
    info: 'default',
};
const ICON_SIZE = 20;
const StyledIconWrapper = styled.div `
  display: flex;
  justify-content: center;
  height: 20px;
`;
const StyledAlert = styled.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  border-radius: 8px;

  padding: 16px;

  ${({ background }) => background &&
    `
    background: ${background};
  `}

  ${({ borderColor }) => borderColor &&
    `
      border: 1px solid ${borderColor};
    `}

  ${space}
`;
export const Alert = (_a) => {
    var { children, severity = 'error', actions } = _a, props = __rest(_a, ["children", "severity", "actions"]);
    const theme = useTheme();
    const colors = useColorSet({
        colorSet: severityMapping[severity],
    });
    return (_jsxs(StyledAlert, Object.assign({ background: colors.background }, (severity === 'info' && { borderColor: colors.border }), props, { children: [props.icon && (_jsx(StyledIconWrapper, { children: _jsx(Icon, { name: props.icon, color: colors.content, size: ICON_SIZE, mr: 12 }) })), _jsxs(Box, { width: "100%", children: [children || (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body", weight: "medium", color: theme.colors.content.default, children: props.title }), props.secondaryText && (_jsx(Typography, { variant: "body", color: theme.colors.content.subdued, children: props.secondaryText }))] })), actions && _jsxs(Box, { mt: 8, children: [" ", actions] })] })] })));
};
